import React from 'react';
import ReactDOM from 'react-dom';
const modalId = document.getElementById('slideshow-modal');

class PopoverModal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement('div');
  }
  componentDidMount() {
    modalId.appendChild(this.el);
  }
  componentWillUnmount() {
    modalId.removeChild(this.el);
  }
  render() {
    return ReactDOM.createPortal(
      this.props.children,
      this.el,
    );
  }
}

export default PopoverModal;



// WEBPACK FOOTER //
// ./src/components/popover/PopoverModal.js